import React from 'react'
import { UserProvider } from '~context/provider'
// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => {
  return <UserProvider>{element}</UserProvider>
}
